export const extractTimestampIfLevelExists = (message: any, id: string): string | null => {
  const hasLevel = message?.data?.data?.some((item: any) => item?.id === id);

  return hasLevel ? message.data.timestamp : null;
};
